import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const RegistroMovimiento = ({ caja, totalesPorPago, onMovimientoRegistrado }) => {
  const [monto, setMonto] = useState('');
  const [concepto, setConcepto] = useState('');
  const [tipoMovimiento, setTipoMovimiento] = useState('egreso');
  const [formaPago, setFormaPago] = useState('efectivo');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // Estado de carga
  const { token } = useAuth();

  const registrarMovimiento = async () => {
    if (!monto || isNaN(monto) || !concepto) {
      setError('Ingrese todos los campos correctamente.');
      setTimeout(() => setError(''), 3000);
      return;
    }
    console.log(caja.id);

    setLoading(true); // Activar estado de carga
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/caja/movimiento`,
        {
          caja_id: caja.id,
          tipo_movimiento: tipoMovimiento,
          monto: parseFloat(monto),
          concepto: concepto,
          forma_pago: formaPago,
        },
        {
          headers: { 'x-auth-token': token },
        }
      );

      alert("Movimiento registrado con éxito")
      setError('');
      onMovimientoRegistrado(); // <-- solo refresca la caja

      setMonto('');
      setConcepto('');
    } catch (error) {
      console.error("Error al registrar el movimiento:", error);
      setError('Error al registrar el movimiento.');
      setTimeout(() => setError(''), 3000);
    } finally {
      setLoading(false); // Desactivar estado de carga
    }
  };

    return (
      <div className="max-w-md mx-auto  p-0">
        <div className="rounded-2xl shadow bg-white/95 px-0 py-0 overflow-hidden">
          <h2 className="text-xl font-bold text-center text-gray-800 py-5 border-b border-gray-100 bg-gray-50">Registro de Movimiento</h2>
          <form
            className="grid grid-cols-1 gap-0 divide-y divide-gray-100"
            onSubmit={e => { e.preventDefault(); registrarMovimiento(); }}
            autoComplete="off"
          >
            <div className="flex flex-col px-6 py-4 bg-white">
              <label className="text-xs font-semibold text-gray-500 mb-1">Monto</label>
              <input
                type="number"
                value={monto}
                onChange={e => setMonto(e.target.value)}
                className="rounded-md border border-gray-200 px-3 py-2 focus:ring-2 focus:ring-green-300 focus:border-green-400 outline-none text-lg text-center bg-gray-50"
                placeholder="$0.00"
                min="0"
                step="0.01"
                required
              />
            </div>
            <div className="flex flex-col px-6 py-4 bg-white">
              <label className="text-xs font-semibold text-gray-500 mb-1">Concepto</label>
              <input
                type="text"
                value={concepto}
                onChange={e => setConcepto(e.target.value)}
                className="rounded-md border border-gray-200 px-3 py-2 focus:ring-2 focus:ring-green-300 focus:border-green-400 outline-none text-base bg-gray-50"
                placeholder="Ej: Pago proveedor"
                maxLength={40}
                required
              />
            </div>
            <div className="flex flex-col px-6 py-4 bg-white">
              <label className="text-xs font-semibold text-gray-500 mb-1">Tipo</label>
              <select
                value={tipoMovimiento}
                onChange={e => setTipoMovimiento(e.target.value)}
                className="rounded-md border border-gray-200 px-3 py-2 focus:ring-2 focus:ring-green-300 focus:border-green-400 outline-none text-base bg-gray-50"
              >
                <option value="ingreso">Entrada</option>
                <option value="egreso">Salida</option>
              </select>
            </div>
            <div className="flex flex-col px-6 py-4 bg-white">
              <label className="text-xs font-semibold text-gray-500 mb-1">Forma de Pago</label>
              <select
                value={formaPago}
                onChange={e => setFormaPago(e.target.value)}
                className="rounded-md border border-gray-200 px-3 py-2 focus:ring-2 focus:ring-green-300 focus:border-green-400 outline-none text-base bg-gray-50"
              >
                <option value="efectivo">Efectivo</option>
                <option value="tarjeta">Tarjeta</option>
                <option value="transferencia">Transferencia</option>
                <option value="otros">Otros</option>
                <option value="cuentaCorriente">Cuenta Corriente</option>
              </select>
            </div>
            <div className="flex flex-col px-6 py-4 bg-white">
              <button
                type="submit"
                disabled={loading}
                className={`w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-lg shadow transition-all duration-150 ${loading ? 'opacity-60 cursor-not-allowed' : ''}`}
              >
                {loading ? 'Procesando...' : 'Registrar Movimiento'}
              </button>
              {error && <div className="mt-3 text-center text-red-600 font-semibold bg-red-50 rounded-lg py-2">{error}</div>}
            </div>
          </form>
        </div>
      </div>
    );
};

export default RegistroMovimiento;
